// Format token amount
export const formatTokenAmount = (amount, exponent) => amount / Math.pow(10, exponent)


export default formatTokenAmount